import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'మా ఎంపిక',
  bestPriceBadge: 'ఉత్తమ ధర',
  regulatedNotice: {
    prescriptionOnly: 'ప్రిస్క్రిప్షన్‌తో మాత్రమే',
    professionalUse: 'వృత్తిపరమైన ఉపయోగం కోసం',
    fromVeterinarian: 'మీ పశువైద్యుడి వద్ద లభిస్తుంది',
    fromPharmacist: 'ఫార్మసిస్ట్ వద్ద లభిస్తుంది',
    noOnlinePurchase: 'ఆన్‌లైన్‌లో అమ్మబడదు',
    professionalSupply: 'వృత్తిపరమైన సరఫరాదారుల ద్వారా అమ్మబడుతుంది',
    whyNoLink: 'ఈ ఉత్పత్తిని మేము సమీక్షిస్తాము, కానీ దానికి లింక్ ఇవ్వము.',
  },
};
